import { useClient } from 'hooks/useClient';
import { CINCELClient } from '@cincel/client';
import { resolveTokenV3 } from 'helpers/sessionContext';
import { useQuery } from 'react-query';

const fetchCertificateService = async (client: CINCELClient, email) => {
  return client.fetchCertificateByUser(email);
};

export const useFetchCertificate = ({ email, enabled = true, token }) => {
  const client = useClient({
    url: process.env.REACT_APP_API_V3,
    token: resolveTokenV3(token),
  });

  const {
    data: certificate,
    status: certificateStatus,
    isLoading: isCertificateLoading,
    refetch: refetchCertificate,
    isError: isCertificateError,
    error: certificateError,
    ...rest
  } = useQuery(
    ['certificate', email],
    () => fetchCertificateService(client, email),
    {
      enabled,
      refetchOnWindowFocus: false,
    },
  );

  return {
    certificate,
    certificateStatus,
    isCertificateLoading,
    refetchCertificate,
    isCertificateError,
    certificateError,
    ...rest,
  };
};
